import { useCallback, useEffect, useState } from "react";
import { StringNumber, TCelula, TCelulaCadastro } from "../../../../types";
import api from "../../../../utils/api";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";


export type ResponseServiceEdit = {
  celulaSelecionada: TCelulaCadastro|undefined;
  cadastrarCelula: VoidFunction;
  changeCampusCelula: (campo: keyof TCelulaCadastro, valor: StringNumber | null) => void;
};

export const ServicesCadastrar = (): ResponseServiceEdit => {
  const [celulaSelecionada, setCelulaSelecionada] = useState<TCelulaCadastro>();

  const { setErrorSuccess } = useErrorSuccess();

  const cadastrarCelula = async () => {
    try {
      const req = await api.post('ministerio/celula', celulaSelecionada);
      const res = await req?.data;
      if(res?.id) {
        setErrorSuccess({ mensagem: 'Celula criada', status: 'success' })
      }else {
        setErrorSuccess({ mensagem: 'error', status: 'error' })
      }
    } catch(error) {
      setErrorSuccess({ mensagem: 'error', status: 'error' })
    }
  };

  const changeCampusCelula = (campo: keyof TCelulaCadastro, value: StringNumber | null) => {
    setCelulaSelecionada(
      (valor: any) => {
      return { ...valor, [campo]: value }
    }
  )
  }

  return {
    celulaSelecionada,
    cadastrarCelula,
    changeCampusCelula
  }
};
